import { AxiosRequestConfig } from "axios";

export const getFindQrConfig = (qrId: string): AxiosRequestConfig => ({
  method: "get",
  url: `/qrcode/${qrId}`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});
